import { portfolioOverviewApi } from './portfolioOverview';
import { dashboardApi } from './dashboard';
import { monitorApi } from './monitor';
import { paymentBehaviorApi } from './paymentBehavior';
import { monitorRulesApi } from './monitorRules';

export const api = {
  portfolio: portfolioOverviewApi,
  dashboard: dashboardApi,
  monitor: monitorApi,
  paymentBehavior: paymentBehaviorApi,
  monitorRules: monitorRulesApi
};

if (process.env.NODE_ENV === 'development') {
  window.api = api;
}
